'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002431 from "./presto.-Two-Factor-Auth-View$$anon$31.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002433 from "./presto.-Two-Factor-Auth-View$$anon$33.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002435 from "./presto.-Two-Factor-Auth-View$$anon$35.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002437 from "./presto.-Two-Factor-Auth-View$$anon$37.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$30(outer) {
  this.bBR = null;
  this.bBJ = null;
  this.bBK = false;
  this.bBS = null;
  this.bBT = false;
  this.bBW = null;
  this.bBP = null;
  this.bBQ = false;
  this.bBL = null;
  this.bBM = false;
  this.bBN = null;
  this.bBO = false;
  this.bBU = false;
  this.bBV = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bBR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bBW = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$30 as $c_Lpresto_TwoFactorAuthView$$anon$30 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$30.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$30;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$30() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$30 as $h_Lpresto_TwoFactorAuthView$$anon$30 };
$h_Lpresto_TwoFactorAuthView$$anon$30.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bBR;
});
$p.L = (function() {
  if ((!this.bBK)) {
    this.bBJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bBK = true;
  }
  return this.bBJ;
});
$p.O = (function() {
  if ((!this.bBT)) {
    this.bBS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bBT = true;
  }
  return this.bBS;
});
$p.E = (function() {
  return this.bBW;
});
$p.t = (function() {
  if ((!this.bBQ)) {
    this.bBP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bBQ = true;
  }
  return this.bBP;
});
$p.M = (function() {
  if ((!this.bBM)) {
    this.bBL = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002431.$c_Lpresto_TwoFactorAuthView$$anon$31(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002433.$c_Lpresto_TwoFactorAuthView$$anon$33())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002435.$c_Lpresto_TwoFactorAuthView$$anon$35())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bBM = true;
  }
  return this.bBL;
});
$p.Q = (function() {
  if ((!this.bBO)) {
    this.bBN = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002437.$c_Lpresto_TwoFactorAuthView$$anon$37();
    this.bBO = true;
  }
  return this.bBN;
});
$p.w = (function() {
  if ((!this.bBV)) {
    this.bBU = false;
    this.bBV = true;
  }
  return this.bBU;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee324) => ((p) => \u03b4scrutinee324.z5(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$30 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$30, "presto.TwoFactorAuthView$$anon$30", ({
  Ss: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$30 as $d_Lpresto_TwoFactorAuthView$$anon$30 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$30.js.map
